export default __webpack_public_path__ + "static/drop_wireless-a26cc43efeecfb73ec5ef5d5c55e9a80.png";